import { types, getParent } from 'mobx-state-tree';
import { user, utils } from "@myplay/all";
import { flow } from "mobx";

import storage from "../../utils/storage";
import { ACCESS_TOKEN, REFRESH_TOKEN, USER_DATA, APP_LOGIN_ROUTE, MYPLAY_APP_BASE, MYPLAY_AD_PANEL_ROUTE } from '../../utils/constants';
import history from '../../utils/history';

const { auth, settings } = user;
const UserData = types
  .model("UserData", {
    _id: types.maybeNull(types.string),
    fullName: types.maybeNull(types.string),
    firstName: types.maybeNull(types.string),
    lastName: types.maybeNull(types.string),
    avatar: types.maybeNull(types.string),
    avatarBgColor: types.maybeNull(types.string),
    phone: types.maybeNull(types.string), 
    birthdate: types.maybeNull(types.string), 
    country: types.maybeNull(types.string)
  });

const UserStore = types
  .model("UserStore", {
    accessToken: types.maybeNull(types.string),
    refreshToken: types.maybeNull(types.string),
    allCountries: types.maybeNull(types.array(types.frozen({}))),
    data: types.maybeNull(UserData)
  })
  .actions(self => ({
    afterCreate: flow(function* afterCreate() {
      self.setTokensFromUrl();
      try {
        const { ClubsStore } = getParent(self);
        let {
          accessToken,
          userData,
          refreshToken
        } = yield self.getUserFromLocalStorage();

        if (accessToken || refreshToken) {
          yield self.setAccessToken(accessToken || "");
          yield self.setRefreshToken(refreshToken || "");
        } else {
          window.location.href = `${APP_LOGIN_ROUTE}/login?redirect=${MYPLAY_AD_PANEL_ROUTE}`;
        };

        const params = new URLSearchParams(window.location.search);
        const paramsId = params.get("userId");
        const { list } = yield utils.getCountriesList();
        self.setCountries(list);
        if (paramsId && (!userData || userData._id !== paramsId)) {
          userData = yield self.fetchUserData(paramsId);
        } else {
          yield self.setUserData(userData || {});
        };
        if (userData && userData._id) {
          yield ClubsStore.getClubsByUser(userData._id);
        }
        if (!history.location.pathname || history.location.pathname === "/") {
          history.push('/sites');
        }

      } catch (error) {
        console.log(error);
      }
    }),
    setAccessToken(token) {
      self.accessToken = token;
      storage.setItem(ACCESS_TOKEN, token);
      auth.setAccessToken(token);
    },
    setRefreshToken(token) {
      self.refreshToken = token;
      storage.setItem(REFRESH_TOKEN, token);
      auth.setRefreshToken(token);
    },
    setTokensFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const accessToken = params.get("accessToken");
      const refreshToken = params.get("refreshToken");
      if (accessToken || refreshToken) {
        self.setAccessToken(accessToken);
        self.setRefreshToken(refreshToken);
      }
    },
    getUserFromLocalStorage: flow(function* getUserFromLocalStorage() {
      try {
        const accessToken = yield storage.getItem(ACCESS_TOKEN);
        const refreshToken = yield storage.getItem(REFRESH_TOKEN);
        const userData = yield storage.getItem(USER_DATA);

        return {
          accessToken,
          refreshToken,
          userData
        };
      } catch (error) {
        console.log(error);
      }

    }),
    setUserData(data) {
      storage.setItem(USER_DATA, data);
      self.data = { ...data };
    },
    fetchUserData: flow(function* fetchUserData(userId) {
      try {
        const userData = yield auth.getUserData(userId);
        self.setUserData(userData);
        return userData;
      } catch (error) {
        console.log(error);
      }
    }),
    logout() {
      self.setUserData(null);
      self.setAccessToken("");
      self.setRefreshToken("");
      window.location.href = `${APP_LOGIN_ROUTE}/logout`;
    },
    setCountries(countries) {
      const copy = []
      countries.map(country => {
        copy.push({ ...country, value: country.name });
      });
      self.allCountries = copy;
    }, 
    updateUserDetails: flow(function* updateUserDetails(details){
      try {
        yield settings.updateUserData(self.data._id, details);
        const newData = yield auth.getUserData(self.data._id);
        self.setUserData(newData);
      } catch (error) {
        console.log(error);
      }
    }),
    updateUserImage: flow(function* updateUserImage(newImg) {
      try {
        yield user.settings.updateProfileImage(self.data._id, newImg);
        const newData = yield auth.getUserData(self.data._id);
        self.setUserData(newData);
      } catch (error) {
        console.log(error);
      }
    }),
  }))

export default UserStore;
